import IconComponent from "icons/IconComponent";

import TrashIcon from "./trash-icon.svg";

export default (TrashIcon as any) as IconComponent;
